<template>
    <input
        @click="toggle()"
        id="search_field"
        class="block w-full h-full pl-8 pr-3 py-2 border-transparent text-gray-900 placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-0 focus:border-transparent sm:text-sm"
        :placeholder="$t('messages.search')"
        type="search"
    />
</template>

<script setup>
import { useGlobalSearch } from '@/composables/globalSearch.js';

const { toggle } = useGlobalSearch();
</script>
